<template>
  <div class="filter">
    <div class="filter-header">
      <b>{{filter.column.name}}</b>
    </div>
    <div class="values">
      <div class="value" v-for="value in filter.values" :key="value.name">
        <v-checkbox
          class="pa-0 ma-0"
          v-model="selectedValues"
          :value="value.name"
          :dense="true"
          :label="`${value.name} (${value.products.length})`"
          hide-details
        ></v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filter: Object
  },
  data: () => ({}),
  computed: {
    selectedValues: {
      get() {
        return this.$store.state.columnIdToValues[this.filter.column.id] || [];
      },
      set(value) {
        this.$store.commit("setColumnIdToValues", {
          column: this.filter.column,
          values: value
        });
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.filter-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.value {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  label {
    flex: auto;
    cursor: pointer;
    //text-transform: capitalize;

    &.left {
      text-align: left;
      font-weight: 300;
    }
    &.right {
      text-align: right;
      font-weight: bold;
    }
  }
}
</style>
